/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './dropdown.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from 'nm-socle-application/app/directives/layout-angular-material.directive';
import * as i3 from '@angular/common';
import * as i4 from 'nm-socle-application/app/components/ng-dropdown/dropdown.component';
import * as i5 from './dropdown-item.component.ngfactory';
import * as i6 from 'nm-socle-application/app/components/ng-dropdown/dropdown-item.component';
const styles_DropdownComponent:any[] = [i0.styles];
export const RenderType_DropdownComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_DropdownComponent,data:{}});
function View_DropdownComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),0,'span',[['class',
      'mr-5']],[[8,'innerHTML',1]],(null as any),(null as any),(null as any),(null as any)))],
      (null as any),(_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = _co.icon;
        _ck(_v,0,0,currVal_0);
      });
}
export function View_DropdownComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),30,'div',[['class',
      'dropdown']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵeld(2,0,(null as any),
          (null as any),27,'div',[['class','btn-group']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),
          ['\n        '])),(_l()(),i1.ɵeld(4,0,(null as any),(null as any),9,'a',[['class',
          'btn'],['layout','row'],['layout-align','start center']],[[4,'display',(null as any)],
          [4,'flex-direction',(null as any)],[4,'display',(null as any)],[4,'justify-content',
              (null as any)],[4,'align-items',(null as any)],[4,'align-content',(null as any)]],
          (null as any),(null as any),(null as any),(null as any))),i1.ɵdid(5,16384,
          (null as any),0,i2.LayoutDirective,([] as any[]),{layout:[0,'layout']},(null as any)),
      i1.ɵdid(6,16384,(null as any),0,i2.LayoutAlignDirective,([] as any[]),{align:[0,
          'align']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n            '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_DropdownComponent_1)),
      i1.ɵdid(9,16384,(null as any),0,i3.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n            '])),
      (_l()(),i1.ɵeld(11,0,(null as any),(null as any),1,'span',([] as any[]),(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted(12,
          (null as any),['',''])),(_l()(),i1.ɵted(-1,(null as any),['    \n        '])),
      (_l()(),i1.ɵted(-1,(null as any),['\n        '])),(_l()(),i1.ɵeld(15,0,(null as any),
          (null as any),3,'a',[['class','btn dropdown-toggle'],['tabindex','0']],(null as any),
          [[(null as any),'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i4.DropdownComponent = _v.component;
            if (('focus' === en)) {
              const pd_0:any = ((<any>_co.onFocus($event)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n            '])),
      (_l()(),i1.ɵeld(17,0,(null as any),(null as any),0,'i',[['class','fa fa-chevron-down mt-5']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n        '])),(_l()(),i1.ɵted(-1,(null as any),
          ['\n        '])),(_l()(),i1.ɵeld(20,0,(null as any),(null as any),8,'div',
          [['class','menu']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),i1.ɵdid(21,278528,(null as any),0,i3.NgClass,[i1.IterableDiffers,
          i1.KeyValueDiffers,i1.ElementRef,i1.Renderer],{klass:[0,'klass'],ngClass:[1,
          'ngClass']},(null as any)),i1.ɵpod(22,{'display-above':0}),i1.ɵdid(23,278528,
          (null as any),0,i3.NgStyle,[i1.KeyValueDiffers,i1.ElementRef,i1.Renderer],
          {ngStyle:[0,'ngStyle']},(null as any)),i1.ɵpod(24,{'max-height':0}),(_l()(),
          i1.ɵted(-1,(null as any),['\n            '])),(_l()(),i1.ɵeld(26,0,(null as any),
          (null as any),1,'dropdown-item',([] as any[]),(null as any),[[(null as any),
              'onItemSelect']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i4.DropdownComponent = _v.component;
            if (('onItemSelect' === en)) {
              const pd_0:any = ((<any>_co.onItemSelectEmit($event)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i5.View_DropdownItemComponent_0,i5.RenderType_DropdownItemComponent)),
      i1.ɵdid(27,573440,(null as any),0,i6.DropdownItemComponent,[i1.ElementRef],{items:[0,
          'items'],selectedItem:[1,'selectedItem']},{onItemSelect:'onItemSelect'}),
      (_l()(),i1.ɵted(-1,(null as any),['\n        '])),(_l()(),i1.ɵted(-1,(null as any),
          ['\n    '])),(_l()(),i1.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    var _co:i4.DropdownComponent = _v.component;
    const currVal_6:any = 'row';
    _ck(_v,5,0,currVal_6);
    const currVal_7:any = 'start center';
    _ck(_v,6,0,currVal_7);
    const currVal_8:any = _co.icon;
    _ck(_v,9,0,currVal_8);
    const currVal_10:any = 'menu';
    const currVal_11:any = _ck(_v,22,0,_co.displayAbove);
    _ck(_v,21,0,currVal_10,currVal_11);
    const currVal_12:any = _ck(_v,24,0,_co.maxHeight);
    _ck(_v,23,0,currVal_12);
    const currVal_13:any = _co.items;
    const currVal_14:any = _co.selectedItem;
    _ck(_v,27,0,currVal_13,currVal_14);
  },(_ck,_v) => {
    var _co:i4.DropdownComponent = _v.component;
    const currVal_0:any = i1.ɵnov(_v,5).display;
    const currVal_1:any = i1.ɵnov(_v,5).direction;
    const currVal_2:any = i1.ɵnov(_v,6).display;
    const currVal_3:any = i1.ɵnov(_v,6).horizontal;
    const currVal_4:any = i1.ɵnov(_v,6).verticalBis;
    const currVal_5:any = i1.ɵnov(_v,6).vertical;
    _ck(_v,4,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5);
    const currVal_9:any = _co.label;
    _ck(_v,12,0,currVal_9);
  });
}
export function View_DropdownComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'dropdown',([] as any[]),
      (null as any),[['window','resize']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('window:resize' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,1).onResize($event)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },View_DropdownComponent_0,RenderType_DropdownComponent)),i1.ɵdid(1,573440,(null as any),
      0,i4.DropdownComponent,[i1.ElementRef],(null as any),(null as any))],(null as any),
      (null as any));
}
export const DropdownComponentNgFactory:i1.ComponentFactory<i4.DropdownComponent> = i1.ɵccf('dropdown',
    i4.DropdownComponent,View_DropdownComponent_Host_0,{items:'items',label:'label',
        icon:'icon',selectedItem:'selectedItem',adaptativeHeight:'adaptativeHeight',
        fullHeightInPx:'fullHeightInPx',intermediateHeightInPx:'intermediateHeightInPx'},
    {onSelectCallback:'onSelectCallback'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/src/$$_gendir/node_modules/nm-socle-application/app/components/ng-dropdown/dropdown.component.ngfactory.ts